import { createFileRoute } from "@tanstack/react-router"
import { CheckCircle, Loader2, XCircle } from "lucide-react"
import { useEffect, useState } from "react"

import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/components/ui/card"
import { publicConfirmSubscription } from "@/http/changelog/public"

export const Route = createFileRoute("/changelog/confirm/$token")(
  {
    component: ConfirmPage,
  },
)

function ConfirmPage() {
  const { token } = Route.useParams()
  const [status, setStatus] = useState<
    "loading" | "success" | "error"
  >("loading")

  useEffect(() => {
    let cancelled = false
    setStatus("loading")

    publicConfirmSubscription(token)
      .then(() => {
        if (!cancelled) setStatus("success")
      })
      .catch(() => {
        if (!cancelled) setStatus("error")
      })

    return () => {
      cancelled = true
    }
  }, [token])

  return (
    <div className="flex min-h-svh items-center justify-center px-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          {status === "loading" && (
            <Loader2 className="text-muted-foreground mx-auto size-10 animate-spin" />
          )}
          {status === "success" && (
            <CheckCircle className="mx-auto size-10 text-emerald-500 dark:text-emerald-400" />
          )}
          {status === "error" && (
            <XCircle className="mx-auto size-10 text-destructive" />
          )}
          <CardTitle className="mt-4">
            {status === "loading" && "Confirmando inscrição..."}
            {status === "success" && "Inscrição confirmada!"}
            {status === "error" && "Link inválido ou expirado"}
          </CardTitle>
        </CardHeader>
        <CardContent className="text-muted-foreground text-center">
          {status === "success" &&
            "Você receberá notificações sobre novas atualizações."}
          {status === "error" &&
            "O link de confirmação pode ter expirado. Tente se inscrever novamente."}
        </CardContent>
      </Card>
    </div>
  )
}
